// extracted by mini-css-extract-plugin
export var callCard = "_pd-0";
export var callMessageButton = "_pd-1";
export var helpIcon = "_pd-3";
export var helpIconContainer = "_pd-4";
export var verticalDivider = "_pd-2";